(() => {
  function quantityBounds(input) {
    const maximum = input.max ?? input.dataset?.tobaMax;
    return {
      minimum: Number(input.min || input.dataset?.tobaMin || 1),
      maximum: maximum === undefined || maximum === '' ? Infinity : Number(maximum),
    };
  }

  function syncQuantityButtons(input) {
    const control = input.closest?.('[data-toba-quantity]');
    if (!control) return;
    const { minimum, maximum } = quantityBounds(input);
    const quantity = Number(input.value);
    for (const option of input.options || []) option.disabled = Number(option.value) > maximum;
    for (const button of control.querySelectorAll('[data-toba-quantity-step]')) {
      button.disabled = input.disabled || maximum < minimum ||
        (Number(button.dataset.tobaQuantityStep) > 0 ? quantity >= maximum : quantity <= minimum);
    }
  }

  function validate(form) {
    const totals = { calendar: 0, charm: 0 };
    let blocked = false;
    for (const input of form.querySelectorAll('[data-toba-kind]')) {
      const quantity = Number(input.value);
      const kind = input.dataset.tobaKind;
      if (input.value === '' || !Number.isSafeInteger(quantity) || quantity < 0) {
        blocked = true;
      } else if (kind in totals) {
        totals[kind] += quantity;
      } else if (quantity > 0) {
        blocked = true;
      }
    }
    blocked ||= totals.calendar > 5 || totals.charm > 3;
    for (const input of form.querySelectorAll('[data-toba-kind]')) {
      const kind = input.dataset.tobaKind;
      const limit = kind === 'calendar' ? 5 : kind === 'charm' ? 3 : 0;
      input.max = String(Math.max(0, limit - (totals[kind] || 0) + (Number(input.value) || 0)));
    }
    form.querySelector('[data-toba-limit-error]').hidden = !blocked;
    const checkout = form.querySelector('[data-toba-checkout]');
    if (checkout) checkout.disabled = blocked;
    return !blocked;
  }
  function attach() {
    document.querySelectorAll('[data-toba-share]').forEach(button => {
      if (button.dataset.shareAttached) return;
      button.dataset.shareAttached = 'true';
      button.addEventListener('click', async () => {
        const area = button.closest('.toba-share-area');
        const status = area.querySelector('[data-toba-share-status]');
        const field = area.querySelector('[data-toba-share-url]');
        const url = new URL(button.dataset.shareUrl || window.location.href, window.location.origin).href;
        const showLink = () => {
          field.value = url;
          field.hidden = false;
          field.focus();
          field.select();
        };
        button.disabled = true;
        status.textContent = '';
        try {
          if (navigator.share) {
            await navigator.share({ title: button.dataset.shareTitle, url });
          } else if (navigator.clipboard?.writeText) {
            await navigator.clipboard.writeText(url);
            status.textContent = button.dataset.shareCopied;
          } else {
            showLink();
          }
        } catch (failure) {
          if (failure.name !== 'AbortError') showLink();
        } finally {
          button.disabled = false;
        }
      });
    });
    document.querySelectorAll('[data-toba-quantity]').forEach(control => {
      if (control.dataset.quantityAttached) return;
      control.dataset.quantityAttached = 'true';
      const input = control.querySelector('[name="quantity"]');
      if (!input) return;
      input.addEventListener('input', () => syncQuantityButtons(input));
      input.addEventListener('change', () => syncQuantityButtons(input));
      control.querySelectorAll('[data-toba-quantity-step]').forEach(button => {
        button.addEventListener('click', () => {
          if (input.disabled || button.disabled) return;
          const { minimum, maximum } = quantityBounds(input);
          if (maximum < minimum) return;
          const current = Number(input.value);
          const quantity = Number.isSafeInteger(current) ? current : minimum;
          const step = Number(input.step || 1) * Number(button.dataset.tobaQuantityStep);
          input.value = String(Math.max(minimum, Math.min(maximum, quantity + step)));
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
      syncQuantityButtons(input);
    });
    document.querySelectorAll('[data-toba-cart-limits]').forEach(form => {
      if (form.dataset.limitsAttached) return;
      form.dataset.limitsAttached = 'true';
      form.addEventListener('input', () => validate(form));
      form.addEventListener('submit', event => {
        if (!validate(form)) event.preventDefault();
      });
      validate(form);
    });
    document.querySelectorAll('[data-toba-product-id]').forEach(area => {
      const form = area.querySelector('form');
      if (!form || form.dataset.addLimitAttached) return;
      form.dataset.addLimitAttached = 'true';
      const input = form.querySelector('[name="quantity"]');
      const button = form.querySelector('[name="add"]');
      const error = area.querySelector('[data-toba-add-error]');
      let busy = false;
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (busy) return;
        busy = true;
        button.disabled = true;
        error.hidden = true;
        let remaining = Number(area.dataset.tobaMax);
        try {
          const response = await fetch(area.dataset.tobaCartUrl + '.js', {cache: 'no-store'});
          if (!response.ok) throw new Error('カートを確認できませんでした。もう一度お試しください。');
          const cart = await response.json();
          const total = cart.items.filter(item => String(item.product_id) === area.dataset.tobaProductId)
            .reduce((sum, item) => sum + item.quantity, 0);
          remaining = Math.max(0, Number(area.dataset.tobaMax) - total);
          input.max = String(remaining);
          input.disabled = remaining === 0;
          syncQuantityButtons(input);
          const quantity = Number(input.value);
          if (!Number.isSafeInteger(quantity) || quantity < 1 || quantity > remaining) {
            error.textContent = remaining === 0
              ? 'カート内の数量が上限に達しています。数量の変更はカートで行ってください。'
              : '追加できる数量はあと' + remaining + '点です。数量を減らしてください。';
            error.hidden = false;
            return;
          }
          const added = await fetch(area.dataset.tobaCartUrl + '/add.js', {method: 'POST', body: new FormData(form)});
          if (!added.ok) {
            const result = await added.json();
            throw new Error(result.description || 'カートに追加できませんでした。もう一度お試しください。');
          }
          window.location.assign(area.dataset.tobaCartUrl);
        } catch (failure) {
          error.textContent = failure.message;
          error.hidden = false;
        } finally {
          busy = false;
          button.disabled = remaining === 0;
        }
      });
    });
  }
  attach();
  document.addEventListener('shopify:section:load', attach);
})();
